import { takeLatest } from 'redux-saga/effects';
import { actions } from '../../ducks/reservation-form-slice';
import { call, select } from 'typed-redux-saga';
import { getPatients } from '../../../services/e-calendar/reservation-form/reservation-form-service';
import { put } from 'typed-redux-saga/macro';
import { getPatientOptionsFromResponse, handleApiError } from './reservation-form-saga.utils';
import {
  changeReservationFormDate,
  reservationEdit,
  submitReservationFormUpdate,
} from './reservation-edit';
import { setupReservationAddForm, submitReservationAddForm } from './reservation-add';
import { reservationCreate, submitReservationCreateForm } from './reservation-create';
import TStore from 'types/store';

function* onPatientSearchString({ payload }: { payload: string }) {
  try {
    const providerId: string = yield select((state: TStore) => state.users.business[0].id);
    const response = yield* call(getPatients, providerId, payload);
    yield* put(actions.setPatientOptions(getPatientOptionsFromResponse(response)));
  } catch (error) {
    yield* call(handleApiError, { error });
  }
}

export default function* reservationFormSaga() {
  yield takeLatest(actions.onPatientSearchString, onPatientSearchString);
  yield takeLatest(actions.setupCreateReservationForm, reservationCreate);
  yield takeLatest(actions.setupReservationEditForm, reservationEdit);
  yield takeLatest(actions.submitReservationCreateForm, submitReservationCreateForm);
  yield takeLatest(actions.submitReservationFormUpdate, submitReservationFormUpdate);
  yield takeLatest(actions.changeReservationFormDate, changeReservationFormDate);
  yield takeLatest(actions.setupReservationAddForm, setupReservationAddForm);
  yield takeLatest(actions.submitReservationAddForm, submitReservationAddForm);
}
